<template>
    <div class="d-flex align-items-center gap-2 justify-content-center">
        <template v-if="show">
            <div class="d-flex flex-column">
                <label for="toCurrency" class="mb-1">Currency</label>
                <select class="form-control" id="toCurrency" v-model="record.ToCurrency" required>
                    <option v-for="currency in currencys" :key="currency" :value="currency">
                        {{ currency }}
                    </option>
                </select>
            </div>
            <div class="d-flex flex-column">
                <label for="convertValue" class="mb-1">Convert Value</label>
                <input type="number" class="form-control" id="convertValue" v-model="record.ConvertValue" required>
            </div>
            <span class="cursor-pointer" @click="handleSave">
                <img src="save-icon.png" alt="Save" style="width:25px;height:25px;object-fit:contain">
            </span>
        </template>
        <template v-else>
            <span v-if="isFetching" class="spinner-border spinner-border-sm text-secondary" role="status" aria-hidden="true"></span>
            <span v-else class="cursor-pointer" @click="toggleShow">
                <img src="corte-de-ojos.png" alt="Edit" style="width:25px;height:25px;object-fit:contain">
            </span>
        </template>
    </div>
</template>
<script>
import RecordMixin from '@/components/tools/RecordMixin.vue';
export default {
    name: 'CurrencyRateRow',
    props: ['reference'],
    mixins: [RecordMixin],
    mounted() {
        this.record.Reference = this.reference;
    },
    data() {
        return {
            show:false,
            table: 'bookingcc',
            isUploading: false,
            isFetching: false,
        };
    },
    async created () {
      this.ready = false;
      if (this.id) {
        await this.fetchRecord();
      }
      this.ready = true;
    },
    computed: {
      currencys() {
        return this.$store.state.currencys;
      }
    },
    methods: {
        async fetchCurrencyRate() {
            if (this.reference) {
                const response = await window.api.get(`/api/bookingcc_ref/${this.reference}`);
                if (response) {
                    this.record = response;
                    this.isNewRecord = false;
                }
            }
        },
        async toggleShow() {
            this.isFetching = true;
            await this.fetchCurrencyRate();
            this.show = !this.show;
            this.isFetching = false;
        },
        async handleSave() {
            if (!this.reference) {
                this.$root.$refs.index.showNotification('La referencia es requerida para guardar el tipo de cambio', 'danger');
                return;
            }

            this.$store.commit('setProcessing', true);
            try {
                this.record.Reference = this.reference;
                const id = this.record.id || 0;
                const res = await window.api.save(`/api/${this.table}/${id}`, this.record, (response) => {
                    this.$root.$refs.index.showNotification(response, 'danger');
                });
                if (res) {
                    this.record = res;
                    this.isNewRecord = false;
                    this.$root.$refs.index.showNotification('Record saved successfully!', 'success');
                    this.show = false;
                }
            } finally {
                this.$store.commit('setProcessing', false);
            }
        },
        
    },
}
</script>